import { createClient, type SupabaseClient } from '@supabase/supabase-js';

let client: SupabaseClient | null | undefined;

/**
 * Helmway client on the publishable key, or null when the build has no URL or key (CI, tests, a
 * fresh clone). Scores then stay in the localStorage cache only.
 */
export function getSupabaseClient(): SupabaseClient | null {
  if (client !== undefined) {
    return client;
  }

  const url = import.meta.env.VITE_SUPABASE_URL?.trim() ?? '';
  const key = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY?.trim() ?? '';
  // Playwright's preview build still reads .env.local. An e2e race must not write Helmway rows,
  // and Top lists assertions expect only the runs the spec seeded.
  const automated = typeof navigator !== 'undefined' && navigator.webdriver;

  client =
    url && key && !automated
      ? createClient(url, key, {
          auth: { persistSession: false, autoRefreshToken: false, detectSessionInUrl: false },
        })
      : null;
  return client;
}
